// File: src/utils/formatTextUtils.js
// Create this file in src/utils/ folder

export const formatTextWithBullets = (text) => {
  if (!text) return "";

  // Split text by newlines
  const lines = text.split("\n");

  // Process each line
  return lines
    .map((line) => {
      // Remove existing bullet points if any
      const cleanLine = line.replace(/^[•·▪▸-]\s*/, "").trim();

      // Add bullet point if line has content
      if (cleanLine) {
        return `• ${cleanLine}`;
      }
      return "";
    })
    .filter(Boolean)
    .join("\n");
};

export const cleanBulletPoints = (text) => {
  if (!text) return "";

  return text
    .split("\n")
    .map((line) => line.replace(/^[•·▪▸-]\s*/, "").trim())
    .filter(Boolean)
    .join("\n");
};

export const extractTextFromHTML = (html) => {
  if (!html) return "";

  // Create a temporary div to extract text from HTML
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || "";
};
